import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonList,
  IonModal,
  IonPopover,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import dayjs from "dayjs";
import { alert, alertOutline, search, searchOutline } from "ionicons/icons"; //@ts-ignore
import React, { useEffect, useState } from "react";
import CustomDesplegable from "../../components/CustomDesplegable/CustomDesplegable";
import DialogoConfirmacion from "../../components/DialogoConfirmacion/DialogoConfirmacion";
import StyledButton from "../../components/StyledButton/StyledButton";
import { DesplegableModel, ErroresPaciente, Mutual, Paciente, TipoDocumento } from "../../interfaces";

import { useHistory } from "react-router";
import { COLORS } from "../../constants/app";
import http from "../../hooks/httpAdapter";
import { useSession } from "../../hooks/SessionContext";
import useTituloPagina from "../../hooks/tituloPagina";
import { useApiRequest } from "../../hooks/useApiRequest";
import { transformers } from "../../utils/transformers";
import { validators } from "../../utils/validaciones";

interface ContainerProps {
  abrirModal: boolean;
  setAbrirModal: (abrir: boolean) => void;
  setPacienteRegistrado: (pacienteCargado: Paciente) => void;
}

//@ts-ignore
const RegistrarPaciente: React.FC<ContainerProps> = ({ abrirModal, setAbrirModal, setPacienteRegistrado }) => {
  const [erroresPaciente, setErroresPaciente] = useState<ErroresPaciente>({
    hc: false,
    documentoNro: false,
    documentoTipo: false,
    documentoTipoNombre: false,
    nombre: false,
    apellido: false,
    mutual: false,
    mutualNombre: false,
    telefono: false,
    celular: false,
    email: false,
    sexo: false,
    mutualAfiliado: false,
    nacimiento: false,
  });
  const [mutuales, setMutuales] = useState<Mutual[]>([]);
  const [tiposDoc, setTiposDoc] = useState<TipoDocumento[]>([]);
  const [mutualesSelect, setMutualesSelect] = useState<DesplegableModel[]>([]);
  const [tiposDocSelect, setTiposDocSelect] = useState<DesplegableModel[]>([]);
  const [abrirCancelarRegistro, setAbrirCancelarRegistro] = useState<boolean>(false);

  const [openTiposDocumentoSelect, setOpenTiposDocumentoSelect] = useState(false);
  const [openMutualesSelect, setOpenMutualesSelect] = useState(false);

  const { pacienteCargado, setPacienteCargado, hcUL, cargandoSession, setSesionInvalida, mostrarNotificacion } = useSession();
  const history = useHistory();
  useTituloPagina();

  const { executeRequest: ejecutarTiposDocs } = useApiRequest();

  const CargarTiposDocs = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${hcUL?.token}`,
      },
    };

    await ejecutarTiposDocs(() => http().get(`Pacientes/DocumentoTipoTraer`, config), {
      onSuccess: (response) => {
        const listado = transformers.toDesplegable(response);
        setTiposDoc(response);
        setTiposDocSelect(listado);
      },
    });
  };

  const { executeRequest: ejecutarMutuales } = useApiRequest();

  const CargarMutuales = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${hcUL?.token}`,
      },
    };

    await ejecutarMutuales(() => http().get(`Mutuales`, config), {
      onSuccess: (response) => {
        const listado = transformers.toDesplegable(response, "hojaRuta");
        setMutuales(response);
        setMutualesSelect(listado);
      },
    });
  };

  useEffect(() => {
    if (cargandoSession === false) {
      CargarMutuales();
      CargarTiposDocs();
    }
  }, [cargandoSession]);

  const handleChangeInput = (value: any, id: string) => {
    let pacienteModificado = { ...pacienteCargado };

    switch (id) {
      case "mutual":
        mutuales.forEach((mutual: any) => {
          if (mutual.codigo === value) {
            pacienteModificado.mutual = mutual.codigo;
            pacienteModificado.mutualNombre = mutual.nombre;
          }
        });
        break;
      case "documentoTipo":
        tiposDoc.forEach((tipo: any) => {
          if (tipo.codigo === value) {
            pacienteModificado.documentoTipo = tipo.codigo;
            pacienteModificado.documentoTipoNombre = tipo.nombre;
          }
        });
        break;
      case "nombre":
        pacienteModificado.nombre = value;
        break;
      case "apellido":
        pacienteModificado.apellido = value;
        break;
      case "nacimiento":
        pacienteModificado.nacimiento = value;
        break;
      case "documentoNro":
        pacienteModificado.documentoNro = value;
        break;
      case "mutualAfiliado":
        pacienteModificado.mutualAfiliado = value;
        break;
      case "telefono":
        pacienteModificado.telefono = value;
        break;
      case "email":
        pacienteModificado.email = value;
        break;
      default:
        mostrarNotificacion(true, "Selección inválida", COLORS.ERROR);
        break;
    }
    setPacienteCargado(pacienteModificado);
  };

  const validarFormRegistroPaciente = (): boolean => {
    let errores: ErroresPaciente = {
      hc: false,
      documentoNro: false,
      documentoTipo: false,
      documentoTipoNombre: false,
      nombre: false,
      apellido: false,
      mutual: false,
      mutualNombre: false,
      telefono: false,
      celular: false,
      email: false,
      sexo: false,
      mutualAfiliado: false,
      nacimiento: false,
    };

    let pasa = true;
    if (!validators.campoRequerido(pacienteCargado?.nombre)) {
      pasa = false;
      errores.nombre = true;
    }
    if (!validators.campoRequerido(pacienteCargado?.apellido)) {
      pasa = false;
      errores.apellido = true;
    }
    if (!validators.campoRequerido(pacienteCargado?.nacimiento)) {
      pasa = false;
      errores.nacimiento = true;
    }
    if (!validators.campoRequerido(pacienteCargado?.telefono)) {
      pasa = false;
      errores.telefono = true;
    }
    if (!validators.documento(pacienteCargado?.documentoNro || 0)) {
      pasa = false;
      errores.documentoNro = true;
    }
    if (pacienteCargado === null || !validators.email(pacienteCargado?.email || "")) {
      pasa = false;
      errores.email = true;
    }
    if (
      pacienteCargado === null ||
      pacienteCargado?.documentoTipo === null ||
      !tiposDoc.some((tipo: any) => tipo.codigo === pacienteCargado?.documentoTipo)
    ) {
      pasa = false;
      errores.documentoTipo = true;
    }
    if (pacienteCargado === null || pacienteCargado?.mutual === null || !mutuales.some((mutual: any) => mutual.codigo === pacienteCargado?.mutual)) {
      pasa = false;
      errores.mutual = true;
    }
    if ((pacienteCargado?.mutualAfiliado === "" || pacienteCargado?.mutualAfiliado === null) && pacienteCargado?.mutual !== 1) {
      pasa = false;
      errores.mutualAfiliado = true;
    }
    setErroresPaciente(errores);
    return pasa;
  };

  const limpiarCampos = () => {
    setPacienteCargado({
      codigo: 0,
      hc: 0,
      documentoNro: 0,
      documentoTipo: 0,
      documentoTipoNombre: "",
      nombre: "",
      apellido: "",
      mutual: 0,
      mutualNombre: "",
      telefono: "",
      celular: "",
      email: "",
      sexo: "",
      mutualAfiliado: "",
      nacimiento: "",
      password: "",
    });
  };

  const limpiarErrores = () => {
    setErroresPaciente({
      hc: false,
      documentoNro: false,
      documentoTipo: false,
      documentoTipoNombre: false,
      nombre: false,
      apellido: false,
      mutual: false,
      mutualNombre: false,
      telefono: false,
      celular: false,
      email: false,
      sexo: false,
      mutualAfiliado: false,
      nacimiento: false,
    });
  };

  const RegistrarPaciente = async () => {
    var config = {
      headers: { Authorization: `Bearer ${hcUL?.token}` },
    };

    //Hay que revisar el endpoint, si falla la peticion salta al catch
    try {
      if (pacienteCargado !== null) {
        if (validarFormRegistroPaciente()) {
          const response = await http()
            .post(
              `pacientes`,
              {
                hc: pacienteCargado.documentoNro,
                documentoNro: pacienteCargado.documentoNro,
                password: pacienteCargado.documentoNro,
                documentoTipo: pacienteCargado.documentoTipo,
                documentoTipoNombre: pacienteCargado.documentoTipoNombre,
                nombre: pacienteCargado.nombre,
                apellido: pacienteCargado.apellido,
                mutual: pacienteCargado.mutual,
                mutualNombre: pacienteCargado.mutualNombre,
                celular: pacienteCargado.telefono,
                email: pacienteCargado.email,
                nacimiento: pacienteCargado.nacimiento,
                mutualAfiliado: pacienteCargado.mutual !== 1 ? pacienteCargado.mutualAfiliado : "-",
              },

              config
            )
            .catch((e) => {
              if (e.response && e.response.status === 401) {
                setSesionInvalida(true);
                // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
              } else {
                console.error(e);
              }
            });

          mostrarNotificacion(true, "Paciente  registrado exitosamente", COLORS.SUCCESS);

          setPacienteRegistrado(pacienteCargado);
          limpiarErrores();
          limpiarCampos();
          setAbrirModal(false);
        } else {
          mostrarNotificacion(true, "Faltan de rellenar algunos campos", COLORS.ERROR);
        }
      } else {
        setErroresPaciente({
          hc: true,
          documentoNro: true,
          documentoTipo: true,
          documentoTipoNombre: true,
          nombre: true,
          apellido: true,
          mutual: true,
          mutualNombre: true,
          telefono: true,
          celular: true,
          email: true,
          sexo: true,
          mutualAfiliado: true,
          nacimiento: true,
        });
        mostrarNotificacion(true, "Faltan de rellenar todos los campos", COLORS.ERROR);
      }
    } catch (e) {
      //@ts-ignore
      mostrarNotificacion(true, e?.data.message || e.message, COLORS.ERROR);
    }
  };

  const confirmarCancelarRegistro = () => {
    togleAbrirCerrarCancelarRegistro();
    limpiarCampos();
    limpiarErrores();
  };

  const togleAbrirCerrarCancelarRegistro = () => {
    setAbrirCancelarRegistro(!abrirCancelarRegistro);
  };

  const handleClickRegistrarPaciente = () => {
    RegistrarPaciente();
  };

  return (
    <IonModal isOpen={abrirModal} onDidDismiss={() => setAbrirModal(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Registrar paciente</IonTitle>

          <StyledButton slot="end" lines="none" expand="block" className="rojo ion-padding-horizontal" onClick={() => setAbrirModal(false)}>
            Cancelar
          </StyledButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          {/* <IonNote>Datos del pacienteCargado</IonNote> */}
          <IonItem>
            <IonInput
              label="Nombre"
              id="nombre"
              label-placement="floating"
              value={pacienteCargado?.nombre}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "nombre")}
              className={`${erroresPaciente.nombre && "ion-invalid"}`}
            />

            {erroresPaciente.nombre && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorNombre" size="small" color="danger" />
                <IonPopover trigger="btnErrorNombre" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso el nombre</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              label="Apellido"
              id="apellido"
              label-placement="floating"
              value={pacienteCargado?.apellido}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "apellido")}
              className={`${erroresPaciente.apellido && "ion-invalid"}`}
            />
            {erroresPaciente.apellido && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorApellido" size="small" color="danger" />
                <IonPopover trigger="btnErrorApellido" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso el apellido</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              label="Tipo de documento"
              label-placement="floating"
              value={pacienteCargado?.documentoTipoNombre}
              onClick={() => setOpenTiposDocumentoSelect(true)}
              className={`${erroresPaciente.documentoTipoNombre && "ion-invalid"}`}
            />
            <IonButton slot="end" fill="clear" onClick={() => setOpenTiposDocumentoSelect(true)}>
              <IonIcon aria-hidden="true" ios={searchOutline} md={search} size="large" />
            </IonButton>
            {erroresPaciente.documentoTipo && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorTipoDoc" size="small" color="danger" />
                <IonPopover trigger="btnErrorTipoDoc" triggerAction="click">
                  <IonContent class="ion-padding">No se selecciono un tipo de documento</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              inputMode="numeric"
              label="Numero de documento"
              id="documentoNro"
              label-placement="floating"
              value={pacienteCargado?.documentoNro !== 0 ? pacienteCargado?.documentoNro : ""}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "documentoNro")}
              className={`${erroresPaciente.documentoNro && "ion-invalid"}`}
            />
            {erroresPaciente.documentoNro && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorNroDocumento" size="small" color="danger" />
                <IonPopover trigger="btnErrorNroDocumento" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso un numero de documento</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              type="date"
              label="Fecha de nacimiento"
              label-placement="floating"
              id="nacimiento"
              value={pacienteCargado?.nacimiento}
              min={dayjs().subtract(110, "year").format("YYYY-MM-DD")}
              max={dayjs().format("YYYY-MM-DD")}
              //@ts-ignore
              onIonChange={(e) => handleChangeInput(e.target.value, "nacimiento")}
              className={`${erroresPaciente.nacimiento && "ion-invalid"}`}
            />
            {erroresPaciente.nacimiento && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorFechaNac" size="small" color="danger" />
                <IonPopover trigger="btnErrorFechaNac" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso una fecha de nacimiento valida</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              label="Telefono"
              label-placement="floating"
              id="telefono"
              value={pacienteCargado?.telefono}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "telefono")}
              className={`${erroresPaciente.telefono && "ion-invalid"}`}
            />
            {erroresPaciente.telefono && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorTelefono" size="small" color="danger" />
                <IonPopover trigger="btnErrorTelefono" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso un telefono de contacto</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              label="Correo electronico"
              label-placement="floating"
              id="email"
              value={pacienteCargado?.email}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "email")}
              className={`${erroresPaciente.email && "ion-invalid"}`}
            />
            {erroresPaciente.email && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorCorreo" size="small" color="danger" />
                <IonPopover trigger="btnErrorCorreo" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso un correo electronico valido</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          {/* <IonNote>Datos de mutual</IonNote> */}
          <IonItem>
            <IonInput
              readonly
              label="Mutual"
              label-placement="floating"
              id="mutualNombre"
              value={pacienteCargado?.mutualNombre}
              // onKeyUp={(e) => documentoNro(e.target.value)}
              className={`${erroresPaciente.mutualNombre && "ion-invalid"}`}
              onClick={() => setOpenMutualesSelect(true)}
            />
            <IonButton slot="end" fill="clear" onClick={() => setOpenMutualesSelect(true)}>
              <IonIcon aria-hidden="true" ios={searchOutline} md={search} size="large" />
            </IonButton>
            {erroresPaciente.mutual && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorMutual" size="small" color="danger" />
                <IonPopover trigger="btnErrorMutual" triggerAction="click">
                  <IonContent class="ion-padding">No se selecciono una mutual</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
          <IonItem>
            <IonInput
              label="Numero de afiliado"
              label-placement="floating"
              id="mutualAfiliado"
              value={pacienteCargado?.mutualAfiliado}
              //@ts-ignore
              onKeyUp={(e) => handleChangeInput(e.target.value, "mutualAfiliado")}
              className={`${erroresPaciente.mutualAfiliado && "ion-invalid"}`}
            />
            {erroresPaciente.mutualAfiliado && (
              <>
                <IonIcon aria-hidden="true" slot="end" ios={alertOutline} md={alert} id="btnErrorMutualAfiliado" size="small" color="danger" />
                <IonPopover trigger="btnErrorMutualAfiliado" triggerAction="click">
                  <IonContent class="ion-padding">No se ingreso un numero de afiliado, en caso de no tener</IonContent>
                </IonPopover>
              </>
            )}
          </IonItem>
        </IonList>
      </IonContent>
      <IonFooter>
        <IonRow className="ion-justify-content-around">
          <IonCol size="6">
            <StyledButton expand="block" className="rojo ion-padding-horizontal" onClick={togleAbrirCerrarCancelarRegistro}>
              Limpiar formulario
            </StyledButton>
          </IonCol>
          <IonCol size="6">
            <StyledButton expand="block" className="verde ion-padding-horizontal" onClick={handleClickRegistrarPaciente}>
              Registrar paciente
            </StyledButton>
          </IonCol>
        </IonRow>
      </IonFooter>

      <CustomDesplegable
        array={tiposDocSelect}
        value={pacienteCargado?.documentoTipo || 0}
        handleChange={handleChangeInput}
        mostrarTodos={false}
        mostrarSearch={true}
        id="documentoTipo"
        open={openTiposDocumentoSelect}
        setOpen={setOpenTiposDocumentoSelect}
      />
      <CustomDesplegable
        array={mutualesSelect}
        value={pacienteCargado?.mutual || 0}
        handleChange={handleChangeInput}
        mostrarTodos={false}
        mostrarSearch={true}
        id="mutual"
        open={openMutualesSelect}
        setOpen={setOpenMutualesSelect}
      />

      <DialogoConfirmacion
        titulo="Limpiar formulario"
        contenido="¿Esta seguro de limpiar el formulario? Se perderan los datos que haya cargado"
        abrirCerrarModal={abrirCancelarRegistro}
        handleclickBotonNo={togleAbrirCerrarCancelarRegistro}
        handleclickBotonSi={confirmarCancelarRegistro}
        colorBotonNo="amarillo"
        colorBotonSi="rojo"
        textoBotonNo="Cancelar"
        textoBotonSi="Estoy seguro"
      />
    </IonModal>
  );
};

export default RegistrarPaciente;
